// AvatarSection.js
import React, { useState } from 'react'
import { Avatar } from '@readyplayerme/visage'
import AvatarLink from './AvatarLink'
import SecondaryButton from '../buttons/SecondaryButton'
import Pencil from '../icons/Pencil'
import AvatarScene from './AvatarScene'
import Loading from '../common/Loading'

const AvatarSection = ({ avatarUrl, animationUrl }) => {
  const [loading, setLoading] = useState(true)
  return (
    <>
      <div className="h-80 w-full md:hidden">
        <AvatarScene avatarUrl={avatarUrl} animationSrc={animationUrl} />
      </div>
      <div className="md:flex md:flex-col gap-4 hidden w-full h-full">
        <div className="h-5/6">
          {loading && (
            <div className="mt-4">
              <Loading />
            </div>
          )}
          <Avatar
            onLoaded={() => setLoading(false)}
            cameraTarget={1.3}
            shadows={true}
            modelSrc={avatarUrl}
            animationSrc={animationUrl}
            cameraInitialDistance={2.2}
          />
        </div>
        <div className="flex gap-2">
          <div className="w-3/5">
            <AvatarLink avatarUrl={avatarUrl} />
          </div>
          <SecondaryButton className="flex w-2/5 gap-2" to="/update-avatar">
            <Pencil color="white" height="20" width="20" /> Edit avatar
          </SecondaryButton>
        </div>
      </div>
    </>
  )
}

export default AvatarSection
